import React, { Component } from "react";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import { withSnackbar } from "notistack";
import get from "lodash/get";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Switch from "@material-ui/core/Switch";

import { instance } from "../../../../../../Actions/AxiosInstance";
import KEYS from "../../../../../../Component/DynamicForm/KEYS";
import DynamicForm from "../../../../../../Component/DynamicForm";
import { integerinputconverter } from "../../../../../../Component/DynamicForm/Fields/Integer";

function outputconverter(fields) {
  return fields.map((field) => ({
    fuelfieldtypeid: field.fuelfieldtypeid,
    isfuelconfig: field.isfuelconfig,
    expensepolicyfieldid: field.expensepolicyfieldid,
    subexpensefieldid: field.subexpensefieldid,
    fieldvalue:
      field.typeid === KEYS.MultiSelect
        ? field.fieldvalue
            .filter(
              (val) =>
                field.value.findIndex(
                  (v) =>
                    v.subexpensefieldvalueid === val.subexpensefieldvalueid,
                ) !== -1,
            )
            .map((field1) => ({
              subexpensefieldvalueid: field1.subexpensefieldvalueid,
              expensepolicyfieldvalueid: field1.expensepolicyfieldvalueid,
              valuename: field1.valuename,
              isfuelconfig: field1.isfuelconfig,
              fueltypeid: field1.fueltypeid,
              fuelfieldtypeid: field1.fuelfieldtypeid,
            }))
        : field.typeid === KEYS.Select
        ? field.fieldvalue
            .filter(
              (val) =>
                field.value.subexpensefieldvalueid ===
                val.subexpensefieldvalueid,
            )
            .map((field1) => ({
              subexpensefieldvalueid: field1.subexpensefieldvalueid,
              expensepolicyfieldvalueid: field1.expensepolicyfieldvalueid,
              valuename: field1.valuename,
              isfuelconfig: field1.isfuelconfig,
              fueltypeid: field1.fueltypeid,
              fuelfieldtypeid: field1.fuelfieldtypeid,
            }))
        : field.fieldvalue
            .map((val) => ({ ...val, valuename: field.value }))
            .map((field1) => ({
              subexpensefieldvalueid: field1.subexpensefieldvalueid,
              expensepolicyfieldvalueid: field1.expensepolicyfieldvalueid,
              valuename: field1.valuename,
              isfuelconfig: field1.isfuelconfig,
              fueltypeid: field1.fueltypeid,
              fuelfieldtypeid: field1.fuelfieldtypeid,
            })),
  }));
}

const getSubCategories = (subcategories) => {
  const x = subcategories.map((sub) => {
    const obj = sub;
    delete obj.isselected;
    delete obj.subcategoryname;
    obj.field = outputconverter(obj.field);
    return obj;
  });
  return x;
};

const getFinalJason = (categories) => {
  const json = categories.map((category) => {
    const object = category;
    delete object.categoryname;
    delete object.categorycode;
    delete object.isselected;
    object.subcategory = getSubCategories(object.subcategory);
    return object;
  });
  return json;
};

class Finish extends Component {
  constructor(props) {
    super(props);
    this.state = {
      step: 3,
      selectedPolicy: props.selectedPolicy,
    };

    this.onSubmit = this.onSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    this.props.onRef({
      onNext: this.onSubmit,
    });
  }

  handleChange(name, e) {
    const { selectedPolicy } = this.state;
    if (name == "isreceiptnotrequire" || name == "isallowedadvance") {
      selectedPolicy[name] = !selectedPolicy[name];
      if (name == "isreceiptnotrequire" && !selectedPolicy[name]) {
        selectedPolicy.receiptmaxamount = null;
      } else if (name == "isallowedadvance" && !selectedPolicy[name]) {
        selectedPolicy.advanceamount = null;
        selectedPolicy.maxleftamount = null;
      }
      this.setState({
        selectedPolicy,
      });
    } else {
      selectedPolicy[name] = e;
      this.setState({
        selectedPolicy,
      });
    }
  }

  onSubmit = () => {
    const { selectedPolicy } = this.state;
    selectedPolicy.category = getFinalJason(selectedPolicy.category);

    if (selectedPolicy.isreceiptnotrequire) {
      if (!selectedPolicy.receiptmaxamount) {
        this.props.enqueueSnackbar("Please enter receipt max amount", {
          variant: "error",
        });
        return;
      } else if (
        parseInt(selectedPolicy.receiptmaxamount) >
        parseInt(selectedPolicy.policylimit)
      ) {
        this.props.enqueueSnackbar(
          "Receipt max amount is cannot be greater than policy limit",
          {
            variant: "error",
          },
        );
        return;
      }
    }
    if (selectedPolicy.isallowedadvance) {
      if (!selectedPolicy.maxleftamount || !selectedPolicy.advanceamount) {
        this.props.enqueueSnackbar("Please fill all required fields", {
          variant: "error",
        });
        return;
      } else if (
        parseInt(selectedPolicy.maxleftamount) >
        parseInt(selectedPolicy.policylimit)
      ) {
        this.props.enqueueSnackbar(
          "Max left amount is cannot be greater than policy limit",
          {
            variant: "error",
          },
        );
        return;
      } else if (
        parseInt(selectedPolicy.advanceamount) >
        parseInt(selectedPolicy.policylimit)
      ) {
        this.props.enqueueSnackbar(
          "Advance amount is cannot be greater than policy limit",
          {
            variant: "error",
          },
        );
        return;
      }
    }
    instance
      .post("expense/expensepolicy", selectedPolicy)
      .then(() => {
        this.props.enqueueSnackbar("Save successfully", {
          variant: "success",
        });
        this.props.setNull();
        this.props.onClosed();
        // this.props.history.push(`${this.props.match.path}/`);
      })
      .catch((error) => {
        const msg = error.response.data.error.message;
        this.props.enqueueSnackbar(msg, {
          variant: "error",
        });
      });
  };

  render() {
    const { classes = {} } = this.props;
    const { selectedPolicy } = this.state;
    console.log("selectedPolicy: ", selectedPolicy, this.props);
    return (
      <div className="stepper-data">
        <Grid container>
          <Grid item xs={12} md={8} sm={12}>
            <div style={{ clear: "right" }}>
              <span style={{ position: "relative", top: 8 }}>
                Allow employee to submit request without any receipt
              </span>
              <span className="floatright">
                <div className="expense-limit-switch">
                  <Switch
                    checked={selectedPolicy.isreceiptnotrequire ? true : false}
                    onChange={() => this.handleChange("isreceiptnotrequire")}
                    value={selectedPolicy.isreceiptnotrequire ? true : false}
                    classes={{
                      switchBase: classes.colorSwitchBase,
                      checked: classes.colorChecked,
                      bar: classes.colorBar,
                    }}
                    color="primary"
                  />
                </div>
              </span>
              {selectedPolicy.isreceiptnotrequire && (
                <div
                  style={{
                    clear: "right",
                    marginBottom: 8,
                    height: 50,
                    background: "#f7f8f8",
                    padding: "6px 16px 0px",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <span style={{ marginTop: 10 }}>
                    Maximum amount without receipt
                  </span>
                  <span className="display-flex">
                    <span style={{ marginRight: 10, marginTop: 10 }}>
                      {
                        this.props.SubscriptionInfo.SubscriptionData
                          .currencycode
                      }{" "}
                    </span>
                    <div style={{ width: 164 }}>
                      <DynamicForm
                        formKey="selectedPolicy_receiptmaxamount"
                        fields={integerinputconverter({
                          value: selectedPolicy.receiptmaxamount,
                          // placeholder: this.props.SubscriptionInfo
                          //   .SubscriptionData.currencycode,
                          className: "bg-color-white",
                        })}
                        onChange={(value) =>
                          this.handleChange("receiptmaxamount", value)
                        }
                      />
                    </div>
                  </span>
                </div>
              )}
            </div>
          </Grid>
          <Grid item xs={12} md={8} sm={12} className="margin-top-16">
            <div style={{ clear: "right" }}>
              <span style={{ position: "relative", top: 8 }}>
                Allow employee to request for advance payment
              </span>
              <div className="floatright">
                <div className="expense-limit-switch">
                  <Switch
                    checked={selectedPolicy.isallowedadvance ? true : false}
                    onChange={() => this.handleChange("isallowedadvance")}
                    value={selectedPolicy.isallowedadvance ? true : false}
                    classes={{
                      switchBase: classes.colorSwitchBase,
                      checked: classes.colorChecked,
                      bar: classes.colorBar,
                    }}
                    color="primary"
                  />
                </div>
              </div>
              {selectedPolicy.isallowedadvance && (
                <div
                  style={{
                    clear: "right",
                    marginBottom: 8,
                    height: 50,
                    background: "#f7f8f8",
                    padding: "6px 16px 0px",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <div style={{ marginTop: 10 }}>
                    Maximum amount for advance
                  </div>
                  <div className="display-flex">
                    <span
                      style={{
                        marginRight: 10,
                        marginTop: 10,
                      }}
                    >
                      {
                        this.props.SubscriptionInfo.SubscriptionData
                          .currencycode
                      }{" "}
                    </span>
                    <div style={{ width: 164 }}>
                      <DynamicForm
                        formKey="selectedPolicy_advanceamount"
                        fields={integerinputconverter({
                          value: selectedPolicy.advanceamount,
                          placeholder: this.props.SubscriptionInfo
                            .SubscriptionData.currencycode,
                          className: "bg-color-white",
                        })}
                        onChange={(value) =>
                          this.handleChange("advanceamount", value)
                        }
                      />
                    </div>
                  </div>
                </div>
              )}
              {selectedPolicy.isallowedadvance && (
                <div
                  style={{
                    clear: "right",
                    marginBottom: 8,
                    height: 50,
                    background: "#f7f8f8",
                    padding: "6px 16px 0px",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <span style={{ marginTop: 10 }}>
                    Lower limit of balance for new advance request
                  </span>
                  <div className="display-flex">
                    <div
                      style={{
                        marginRight: 10,
                        marginTop: 10,
                      }}
                    >
                      {
                        this.props.SubscriptionInfo.SubscriptionData
                          .currencycode
                      }{" "}
                    </div>
                    <div style={{ width: 164 }}>
                      <DynamicForm
                        formKey="selectedPolicy_maxleftamount"
                        fields={integerinputconverter({
                          value: selectedPolicy.maxleftamount,
                          placeholder: this.props.SubscriptionInfo
                            .SubscriptionData.currencycode,
                          className: "bg-color-white",
                        })}
                        onChange={(value) =>
                          this.handleChange("maxleftamount", value)
                        }
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
          </Grid>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  DynamicForm: state.dynamicformReducer,
  Language: state.LanguageAction.Language,
  holidayPlanReducer: state.holidayPlanReducer,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

// export default Finish;
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withSnackbar(Finish));
